<template>
  <header class="header">
    <nav
      class="navbar navbar-expand-lg fixed-top bg-transparent"
      data-spy="affix"
      data-offset-top="197"
    >
      <div class="container">
        <a href="/" class="navbar-brand"
          ><img
            src="../assets/logo/Logo.png"
            width="250"
            alt="logo"
            class="img-fluid"
        /></a>
        <button
          type="button"
          class="navbar-toggler collapsed"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
        >
          <i class="bi bi-list color-white fs-20"></i>
        </button>
        <div
          id="navbarSupportedContent"
          class="collapse navbar-collapse main-menu h-auto"
        >
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a
                href="https://www.gupshup.io"
                target="_blank"
                class="nav-link page-scroll"
                >{{ $t("header.t8") }}</a
              >
            </li>
            <li class="nav-item">
              <a
                v-if="state.profile.isSigned"
                @click="dashboard"
                class="nav-link page-scroll"
                >{{ $t("header.t6") }}</a
              >
              <a
                @click="startLogin"
                class="nav-link page-scroll"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-if="!state.profile.isSigned"
                >{{ $t("header.t7") }}</a
              >
            </li>

            <li
              class="floatleft mobile-language"
              style=" padding-left: 20px;padding-top: 3px;"
            >
              <span style="font-weight: lighter;font-size: 15px;">
                <selectLocale
              /></span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <v-dialog
      max-width="600px"
      min-width="360px"
      content-class="dialogcss"
      Modal
      persistent
      v-model="isDialog"
      v-if="isDialog == true"
    >
      <v-card>
        <v-card-title class="headline">{{ $t("common.login") }}</v-card-title>
        <v-card-title class="cancel" @click.stop="isDialog = false"
          >x</v-card-title
        >
        <v-card-text>
          <div id="login-container-1"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </header>
</template>
<style lang="scss">
@media (max-width: 767px) {
  body {
    padding-top: 50px;
  }
}
@media (min-width: 320px) and (max-width: 960px) {
  .navbar-nav .nav-item {
    margin-left: 50px;
  }
  .mobile-language {
    padding-left: 50px !important;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import router from "../router/router";
import { setLocale } from "../services/firebase";
import selectLocale from "../components/selectLocale";
export default {
  name: "Header",
  components: {
    selectLocale,
  },
  data() {
    return {
      isDialog: false,
    };
  },
  methods: {
    startLogin: function() {
      this.isDialog = true;
      this.$store.dispatch("startLogin");
    },
    dashboard: function() {
      router.push("/admin");
    },
  },
  mounted() {
    setLocale();
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
  },
};
</script>
<!--------------------------->
<style lang="scss">
.navbar {
  .container {
    padding: 5px;
  }
}
.color-white {
  color: white;
}
.fs-20 {
  font-size: 20px;
}
</style>
